module.exports = __webpack_public_path__ + "img/motion-detector-sm.e2940941.svg";